import { Component } from 'react';

function redirectToError(detail) {
  try {
    const q = detail ? '?detail=' + encodeURIComponent(String(detail).slice(0, 200)) : '';
    window.location.replace('/error.html' + q);
  } catch (_) {
    window.location.href = '/error.html';
  }
}

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[React Error Boundary]', error, info);
    redirectToError(error?.message || 'React rendering error');
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 100%)',
          color: '#f8fafc',
          fontFamily: 'Inter, sans-serif',
          textAlign: 'center',
          padding: 24
        }}>
          <div>
            <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
            <h1 style={{ fontSize: '1.4rem', marginBottom: 12 }}>Un problème technique est survenu</h1>
            <p style={{ opacity: 0.75 }}>Redirection vers la page d’erreur…</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
